import React from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Navbar } from "components"
import { useClickOutside } from "hooks"
import CashManagmentCard from "./CashManagmentCard"
import classes from "./CashManagmentSidebar.module.scss"

const CashManagmentSidebar = (props) => {
  const {
    openCashManagmentSidebar,
    setOpenCashManagmentSidebar
  } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  useClickOutside(() => {
    setOpenCashManagmentSidebar(false)
  }, [
    "cash-managment-sidebar",
    "cash-managment-sidebar-hamburger-button"
  ])

  const handleGoBack = () => {
    history.push(
      "/settings?t=",
      { initialTab: "shiftCashier" }
    )
  }

  const { paidIns, paidOuts } = shiftCashier[accountId]

  const modifiedPaidIns =
    paidIns.map(paidIn => ({
      ...paidIn, type: "in"
    }))

  const modifiedPaidOuts =
    paidOuts.map(paidOut => ({
      ...paidOut, type: "out"
    }))

  const array =
    [...modifiedPaidIns, ...modifiedPaidOuts]

  const sortedArray =
    array.sort((a, b) => {
      const dateA = new Date(a.createdAt).getTime()
      const dateB = new Date(b.createdAt).getTime()

      if (dateA >= dateB) return -1

      if (dateA < dateB) return 1

      return 0
    })

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      id="cash-managment-sidebar"
      className={clsx(
        classes["sidebar"],
        openCashManagmentSidebar && classes["open"],
        isLtr && classes["sidebar-ltr"],
        openCashManagmentSidebar && isLtr && classes["open-ltr"]
      )}
    >
      <Navbar
        title={t("مدیریت_صندوق")}
        hideLeftIconInMobileView
        onLeftIconPress={handleGoBack}
        rightSideComponent={() =>
          <button
            className={classes["close"]}
            onClick={() => setOpenCashManagmentSidebar(false)}
          >
            <MdClose
              color="white"
              size={25}
            />
          </button>
        }
      />
      <div className={classes["title"]}>
        {t("برداشت_یا_واریز")}
      </div>
      <div className={classes["scroll"]}>
        {sortedArray.map((item, index) =>
          <CashManagmentCard
            key={index}
            item={item}
          />
        )}
      </div>
    </div>
  )
}

export default CashManagmentSidebar